import React from "react";
import { Select, Flex } from "@chakra-ui/react";

function SelectInputField({ data, onChange }) {
  return (
    <Flex border="1px solid #5B2E4F" bg="#FFFFFF" borderRadius="7px">
      <Flex p="0 15px" justify="center" align="center">
        <Select
          onChange={(e) => onChange(e.target.value)}
          placeholder="Select Option"
          bg="transparent"
          border="none"
          _focus={{
            border: "none",
          }}
        >
          {data.map((item, index) => (
            <option key={index} value={item?.value}>
              {item?.name}
            </option>
          ))}
        </Select>
      </Flex>
    </Flex>
  );
}

export default SelectInputField;
